import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "flex min-w-max flex-col" }
const _hoisted_2 = { class: "mb-4 text-lg font-medium" }
const _hoisted_3 = ["value"]
const _hoisted_4 = { class: "ml-2 cursor-pointer" }

import {
  ref,
  PropType,
  watch,
} from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'RadioChoiceHelper',
  props: {
  items: {
    type: Array as PropType<Array<Record<string, unknown>>>,
    required: true,
  },
  label: {
    type: String,
    required: true,
  },
},
  emits: ["selected"],
  setup(__props, { emit: emits }: { emit: ({
  (e: 'selected', value: Record<string, unknown> | undefined)
}), expose: any, slots: any, attrs: any }) {





const selectedItem = ref<Record<string, unknown> | undefined>(undefined);

watch(() => selectedItem.value, () => {
  emits('selected', selectedItem.value);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, _toDisplayString(__props.label), 1),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "mb-2 flex items-center py-2"
        }, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedItem).value = $event)),
            type: "radio",
            value: item,
            class: "radio checked:bg-red-500"
          }, null, 8, _hoisted_3), [
            [_vModelRadio, selectedItem.value]
          ]),
          _createElementVNode("label", _hoisted_4, [
            _renderSlot(_ctx.$slots, "default", { item: item })
          ])
        ]))
      }), 128))
    ])
  ]))
}
}

})